module.exports = __webpack_public_path__ + "img/social_responsibility_MRC-collage.14912553.jpg";